import { createFileRoute } from "@tanstack/react-router";
import { useSite } from "@/components/site/site-data";
import { PageHeader } from "@/components/site/PageHeader";
import { ThemesGrid } from "@/components/site/ThemesGrid";

export const Route = createFileRoute("/tematica")({
  head: () => ({
    meta: [
      { title: "Tematica ediției a X-a — InvesTenergy 2026" },
      {
        name: "description",
        content:
          "Tematica Conferinței anuale InvesTenergy 2026 și cele 11 teme de dezbatere despre echilibrul puterii în energie.",
      },
      { property: "og:title", content: "Tematica ediției a X-a — InvesTenergy 2026" },
      {
        property: "og:description",
        content: "Temele de dezbatere ale Conferinței anuale InvesTenergy, 6 octombrie 2026.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Tematica,
});

function Tematica() {
  const { blocks, themes } = useSite();
  const intro = (blocks["tematica_intro"]?.body ?? "").split(/\n{2,}/).filter(Boolean);
  const highlight = intro.length > 1 ? intro[intro.length - 1] : null;
  const paragraphs = highlight ? intro.slice(0, -1) : intro;

  return (
    <main>
      <PageHeader title="Tematică" subtitle={blocks["tematica_intro"]?.title ?? ""} />
      <section className="mx-auto max-w-6xl px-6 py-16">
        {paragraphs.map((p, i) => (
          <p key={i} className="mt-6 text-lg leading-relaxed text-foreground/90 first:mt-0">
            {p}
          </p>
        ))}
        {highlight && (
          <div className="relative mt-12 overflow-hidden rounded-2xl border border-primary/25 bg-secondary/60 p-8 shadow-lift md:p-10">
            <span
              aria-hidden
              className="absolute inset-y-0 left-0 w-[5px]"
              style={{ background: "linear-gradient(180deg, #198f31 0%, #00347e 100%)" }}
            />
            <p className="font-display text-2xl font-bold leading-snug text-primary md:text-3xl">
              {highlight}
            </p>
          </div>
        )}
        <p className="mt-12 text-lg leading-relaxed whitespace-pre-line text-foreground/90">
          {blocks["teme_intro"]?.body}
        </p>
      </section>

      <section className="bg-sand py-20">
        <div className="mx-auto max-w-6xl px-6">
          <ThemesGrid themes={themes} eyebrow="Ediția a X-a" />
        </div>
      </section>
    </main>
  );
}
